import React from 'react';
import {alpha} from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import {DatabaseMetadataTableToolbarProps} from './DatabaseMetadataTableComponentsProps';
import {Grid} from '@mui/material';

const DatabaseMetadataTableToolbar: React.FC<DatabaseMetadataTableToolbarProps> = ({
   numSelected,
   onDeleteClick,
   toolbarActionsComponent
}) => {
   return (
      <Toolbar
         sx={{
            pl: {sm: 2},
            pr: {xs: 1, sm: 1},
            ...(numSelected > 0 && {
               bgcolor: theme =>
                  alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity)
            })
         }}
      >
         <Grid container spacing={1}>
            <Grid
               id="database-metadata-table-toolbar-actions"
               container
               item
               alignContent="center"
               xs={8}
               spacing={1}
            >
               {toolbarActionsComponent}
            </Grid>
            <Grid item xs={3} alignContent="center" justifyItems="flex-end">
               {numSelected > 0 && (
                  <Typography
                     sx={{flex: '1 1 100%'}}
                     color="inherit"
                     variant="subtitle1"
                     component="div"
                  >
                     {numSelected} elegidos
                  </Typography>
               )}
            </Grid>
            <Grid item xs={1} alignContent="center">
               {numSelected > 0 && (
                  <Tooltip title="Eliminar">
                     <IconButton onClick={onDeleteClick}>
                        <DeleteIcon />
                     </IconButton>
                  </Tooltip>
               )}
            </Grid>
         </Grid>
      </Toolbar>
   );
};

export default DatabaseMetadataTableToolbar;
